import { render } from "./payStatus.vue?vue&type=template&id=38cd621c&scoped=true"
import script from "./payStatus.vue?vue&type=script&lang=js"
export * from "./payStatus.vue?vue&type=script&lang=js"

import "./payStatus.vue?vue&type=style&index=0&id=38cd621c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38cd621c"]])

export default __exports__